import Vue from "vue";

export const Filters = () => {
    Vue.filter('cep', function (_str) {
        _str = '' + _str;
        if (_str != '' && _str.length < 8) {
            return null;
        }
        return _str.replace(/(\d{2})(\d{3})(\d{3})/g, "\$1.\$2\-\$3");
    });

    Vue.filter('cpf_cnpj', function (_str) {
        if (_str == null) {
            return '-';
        }
        
        var cpfCnpj = _str.replace(/[^\d]/g, '');
        console.log(cpfCnpj);

        if (cpfCnpj == '') {
            return '-';
        } else if (cpfCnpj.length < 14) {
            return cpfCnpj.substr(0, 3) + "." + cpfCnpj.substr(3, 3) + "." + cpfCnpj.substr(6, 3) + "-" + cpfCnpj.substr(9);
        } else {
            return cpfCnpj.substr(0, 2) + "." + cpfCnpj.substr(2, 3) + "." + cpfCnpj.substr(5, 3) + "/" + cpfCnpj.substr(8, 4) + "-" + cpfCnpj.substr(12);
        }
    });

    Vue.filter('formatSize', function (_str) {
        var kb = _str / 1024;
        var mb = 0;
        var gb = 0;

        if (kb > 1024) {
            mb = kb / 1024;
        }

        if (mb > 1024) {
            gb = mb / 1024;
        }

        if (gb >= 1) {
            return gb.toFixed(2) + "Gb";
        }

        if (mb >= 1) {
            return mb.toFixed(2) + "Mb";
        }

        return kb.toFixed(2) + "Kb";
    });

    Vue.filter('jsonparse', function (_str) {
        var object = JSON.parse(_str);

        var jsonString = JSON.stringify(object, null, "\t");

        return jsonString;
    });

    Vue.filter("percent", function (value, decimal) {
        if (decimal == undefined) {
            decimal = 5;
        }
        var numero = (value + '').replace(/[^0-9+\-Ee.]/g, '');
        var n = !isFinite(+numero) ? 0 : +numero;
        var prec = !isFinite(+decimal) ? 0 : Math.abs(decimal);
        var milhar_separador = '.';
        var decimal_separador = ',';
        var sep = milhar_separador;
        var dec = decimal_separador;
        var s = '';

        var toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };

        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');

        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }

        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }

        return s.join(dec);
    });

    Vue.filter('phone', function (_str) {
        _str = '' + _str;
        if (_str == '' || _str.length < 10)
            return null;

        var phone = _str.replace(/[^\d]/g, '');

        if (phone.length < 11) {
            return "(" + phone.substr(0, 2) + ") " + phone.substr(2, 4) + "-" + phone.substr(6);
        } else {
            return "(" + phone.substr(0, 2) + ") " + phone.substr(2, 5) + "-" + phone.substr(7);
        }
    });


// Filter Price and Percent
    Vue.filter("price", function (value) {
        var decimal = 2;
        var numero = (value + '').replace(/[^0-9+\-Ee.]/g, '');
        var n = !isFinite(+numero) ? 0 : +numero;
        var prec = !isFinite(+decimal) ? 0 : Math.abs(decimal);
        var milhar_separador = '.';
        var decimal_separador = ',';
        var sep = milhar_separador;
        var dec = decimal_separador;
        var s = '';

        var toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };

        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');

        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }

        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }

        return s.join(dec);
    });

    //Somente valores numéricos => remove todos os caracteres com excessão de números
    Vue.filter("numeric", value => {
        return value.replace(/\D/g, '');
    });
};